import {} from 'bootstrap-tokenfield'
import 'bootstrap-tokenfield/dist/css/bootstrap-tokenfield.css'

$(document).ready(() => {
  $('input.datepicker').datepicker({
    format: 'yyyy-mm-dd'
  })
})
